import Flex from '@Resources/styles/flex.scss';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import cx from 'classnames';
import _cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import ProcessesApi from '@Data/processes/Api';
import Styles from '../Processes.scss';
import MultiFieldSelectorOption from './MultiFieldSelectorOption';

const MultiFieldSelector = (props) => {
    const { folderFields, fieldName, values, id } = props;

    const handleChangeField = (newField, index) => {
        const clonedFields = _cloneDeep(values);
        clonedFields[index] = newField;
        ProcessesApi.OLDsetPayloadDataAttribute(fieldName, clonedFields);
    };

    const handleDeleteField = (index) => {
        const clonedFields = _cloneDeep(values);
        clonedFields.splice(index, 1);
        ProcessesApi.OLDsetPayloadDataAttribute(fieldName, clonedFields);
    };

    const handleAddNewField = () => {
        const clonedFields = _cloneDeep(values);
        clonedFields.push('');
        ProcessesApi.OLDsetPayloadDataAttribute(fieldName, clonedFields);
    };

    return (
        <div id={id} className={cx(Flex.flex, Flex.column)}>
            {values.map((v, i) => {
                if (i === 0) {
                    return (
                        <MultiFieldSelectorOption
                            id={`${id}-option-${i}`}
                            title={fieldName}
                            folderFields={folderFields}
                            onChangeField={handleChangeField}
                            index={i}
                            key={`mfso${i}`}
                            value={v}
                        />
                    );
                } else {
                    return (
                        <MultiFieldSelectorOption
                            key={`mfso${i}`}
                            folderFields={folderFields}
                            onChangeField={handleChangeField}
                            index={i}
                            value={v}
                            canDelete
                            onDelete={handleDeleteField}
                        />
                    );
                }
            })}

            <div className={Styles.spFolderInputs}>
                <div className={Styles.spFolderLabelContainer} />
                <div
                    className={cx(
                        Styles.spFolderLabelContainer,
                        Styles.spLeftMargin
                    )}
                >
                    <div
                        className={Styles.spAddFieldBtn}
                        onClick={handleAddNewField}
                    >
                        <AddIcon sx={{ marginRight: '.5rem' }} />
                        Add an additional field
                    </div>
                </div>
            </div>
        </div>
    );
};

MultiFieldSelector.propTypes = {
    folderFields: PropTypes.array,
    fieldName: PropTypes.string,
    values: PropTypes.array,
    id: PropTypes.string,
};
export default MultiFieldSelector;
